export default (url) => {
  return new Promise((resolve, reject) => {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.addEventListener('load', function loadListener() {
      this.removeEventListener('load', loadListener);
      resolve(script);
    });
    script.src = url;
    head.appendChild(script);
  });
};
